import React from 'react';
import styled from 'styled-components';
import { Container, Heading, Text, Button } from '../primitives';
import { tokens } from '../../config/themeTokens';

const Wrapper = styled.section`
  padding: ${tokens.spacing.sectionLg} 0;
  text-align: center;
  background: ${tokens.colors.backgroundAlt};
`;

const CtaWrap = styled.div`
  margin-top: ${tokens.spacing.xl};
`;

export function HeroSection({ title, subtitle, ctaLabel, ctaHref, children }) {
  return (
    <Wrapper>
      <Container>
        {title && <Heading level={1}>{title}</Heading>}
        {subtitle && <Text>{subtitle}</Text>}
        {ctaLabel && ctaHref && (
          <CtaWrap>
            <Button as="a" href={ctaHref}>
              {ctaLabel}
            </Button>
          </CtaWrap>
        )}
        {children}
      </Container>
    </Wrapper>
  );
}

export default HeroSection;
